import React, { Component } from 'react';
import InlineSVG from 'svg-inline-react';

import { Cell, ActionCell } from 'components/Table';
import Reactable, {Table, Thead, Th, Tr, Td} from 'reactable';
import SupplementalMaterialsItem from 'components/SupplementalMaterials/SupplementalMaterialsItem';

import { keyedObjToArr } from '../util';

import 'components/SupplementalMaterials/supplementalmaterials.scss';

export default class SupplementalMaterialsList extends Component {

	hasActiveOrder(product){
        let activeOrder = false;
        keyedObjToArr(this.props.orders).forEach((orderItem) => {
            if (orderItem.status === 'active'){
                keyedObjToArr(orderItem.products).forEach((productItem) => {
            	    if(productItem.productId === product.productId) {
                        activeOrder |= true;
            		}
				});
            }
        }, this);
        return activeOrder;
	}

	render () {
		let productList = keyedObjToArr(this.props.products);
        productList.sort(function(a, b) {
            return a.order > b.order;
        });

        return (
			<div className="supplemental-materials inline-grid">
			{productList.map((productItem, index) => {
				return(
					<div key={index}>
						{this.hasActiveOrder(productItem) && (
							<div className="materials-list col-6">
								<div className="product">
									<h4>{productItem.name}</h4>
								</div>
                                {productItem.materials ?
                                    (
										<div className="list">
                                            {keyedObjToArr(productItem.materials).map((materialItem, index2) => {
                                                return(<SupplementalMaterialsItem
													key={index2}
													file={materialItem}
													canEdit={false}
													canDelete={false}
												/>);
                                            }, this)}
										</div>
                                    )
                                    :
                                    (<div className="list">No materials availble.</div>)}
							</div>
						)}
					</div>
			);})}
			</div>
		);
	}

}






// WEBPACK FOOTER //
// ./js/components/SupplementalMaterialsList.js